module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"action-edit":"Bearbeiten","action-delete":"Löschen"},"fr":{"action-delete":"Effacer","action-edit":"Éditer"},"it":{"action-delete":"Cancellare","action-edit":"Modificare"}}')
  delete Component.options._Ctor
}
